import _ = require("lodash")
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {SimulationTypeBO} from "./SimulationTypeBO";
import {
    WB_SimulationTypeInputRelationshipRow,
} from "../PA.Core/PAdbSchemaRows";
import {CustomerBO} from "../PA.MD.BusinessObjects/CustomerBO";

export class SimulationTypeBOValidation {

    static Validation(aBO: SimulationTypeBO): Promise<void> {

        return new Promise<void> ((resolve, error) => {
            SimulationTypeBOValidation.ValidateBusinessUnit(aBO)
                .then((ignore) => {
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                    }

                    return SimulationTypeBOValidation.ValidateFields(aBO)
                })
                .then((ignore) => {
                    resolve()
                    return;
                })

        })
    }

    static ValidateBusinessUnit(aBO: SimulationTypeBO): Promise<void>{
        const self = this;
        let bFlag = false;

        return new Promise((resolve, reject)=> {
            let businessUnit = aBO.WB_SimulationType.cif.WB_BUSINESSUNIT_ID
            if (!businessUnit) {
                console.log(businessUnit)
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'blankBusinessUnit',
                        type: MessageType.Error,
                        title: "Business Unit can't be blank",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('blankBusinessUnit')
            }
            resolve()
        })
    }

    static ValidateFields(aBO: SimulationTypeBO): Promise<void> {
        const self = this;
        let bFlag = false;

        return new Promise((resolve, reject)=>{
            if(aBO.WB_SimulationType.WB_SimulationTypeInputRelationshipRows.length > 1){
                _.forEach(aBO.WB_SimulationType.WB_SimulationTypeInputRelationshipRows, (aRow:WB_SimulationTypeInputRelationshipRow) => {
                    console.log(aBO.WB_SimulationType.WB_SimulationTypeInputRelationshipRows)
                    if (_.isEmpty(aRow.cif.PLACEMENT) && (aRow.cif.DELETED_IND!=='1')) {
                        bFlag = true
                    }
                })
            }


            if(bFlag){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'blankPlacement',
                        type: MessageType.Error,
                        title: "Placement field can't be blank",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('blankPlacement')

            }
            resolve()

        })
    }

}